import { render } from "./department-grid-modal.vue?vue&type=template&id=c9895204"
import script from "./department-grid-modal.vue?vue&type=script&lang=js"
export * from "./department-grid-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__